// 历史事件 组件
<template>
  <div class="pangod-classify-content">
    <div class="timebox">
      <div>
        <i
          class="el-icon-d-arrow-left arrow-icon"
          @click="changeLeft(1)"
          v-show="yearList.length > 10 || isMobile == 1"
        ></i>
        <div id="yearlist" class="yearlist">
          <div
            class="pangod-classify-content-historyitem"
            :class="clickYear === item ? 'activecircle' : ''"
            v-for="(item, index) in yearList"
            :key="index"
            @click="changeYear(item)"
          >
            {{ item }}
          </div>
        </div>
        <i
          class="el-icon-d-arrow-right arrow-icon"
          @click="changeRight(1)"
          v-show="yearList.length > 10 || isMobile == 1"
        ></i>
      </div>
      <el-timeline>
        <el-timeline-item
          v-for="his in historyList"
          :key="his.id"
          :timestamp="his.historyTime"
        >
          <p style="font-size: 16px" v-html="his.content"></p>
        </el-timeline-item>
      </el-timeline>
    </div>
  </div>
</template>

<script>
import { sysHistoryyears, syslistHistory } from "../util/history/history.js";
export default {
  data() {
    return {
      yearList: [], //年限列表
      clickYear: null, //当前年限
      historyList: [], //年限发生事件列表
      domObj: null,
      isMobile: sessionStorage.getItem("isMobile"),
    };
  },
  created() {
    //获取年限
    sysHistoryyears().then((res) => {
      if (res.code === 0) {
        this.yearList = res.data;
        this.clickYear = this.yearList[0];
        this.scrollFunction();
        this.getyearList(this.yearList[0]);
      }
    });
  },
  mounted() {},
  methods: {
    changeLeft(count) {
      var that = this;
      let { yearList, clickYear } = this;

      if (clickYear !== yearList[0]) {
        for (var i in yearList) {
          if (clickYear === yearList[i]) {
            that.clickYear = yearList[i - count];
            that.domObj.scrollLeft = that.domObj.scrollLeft - 120;
            that.getyearList(that.clickYear);
            return;
          }
        }
      }
    },
    changeRight(count) {
      var that = this;
      let { yearList, clickYear } = this;

      if (clickYear !== yearList[yearList.length - 1]) {
        for (var i = 0; i < yearList.length; i++) {
          if (clickYear === yearList[i]) {
            that.clickYear = yearList[i + count];
            that.domObj.scrollLeft = that.domObj.scrollLeft + 120;
            that.getyearList(that.clickYear);
            return;
          }
        }
      }
    },
    changeYear(val) {
      const value = Math.abs(this.clickYear - val);

      if (val < this.clickYear) {
        this.changeRight(value);
      } else if (val > this.clickYear) {
        this.changeLeft(value);
      }
    },
    getyearList(val) {
      var that = this;
      //获取年限发生事件
      syslistHistory({
        year: val,
      }).then((res) => {
        if (res.code === 0) {
          that.historyList = res.data;
        }
      });
    },
    scrollFunction() {
      this.domObj = document.getElementById("yearlist"); // 通过id获取要设置的div
      if (this.domObj.attachEvent) {
        // IE
        this.domObj.attachEvent("onmousewheel", this.mouseScroll);
      } else if (this.domObj.addEventListener) {
        this.domObj.addEventListener("DOMMouseScroll", this.mouseScroll, false);
      }
      this.domObj.onmousewheel = this.domObj.onmousewheel = this.mouseScroll;
    },
  },
};
</script>

<style lang="scss" scoped>
@function pxToRem($args) {
  @return $args / 50 + rem;
}
.pangod-classify-content {
  .timebox {
    width: fit-content;
    margin: 0 auto;

    .el-timeline-item {
      padding-bottom: 60px;
    }
    .el-timeline {
      padding-left: 50px;
    }
    .arrow-icon {
      font-size: 40px;
      color: $theme;
      margin: 30px 10px;
      display: inline-block;
      vertical-align: top;
      cursor: pointer;
      font-weight: bold;
      -webkit-user-select: none; /*webkit浏览器*/
      -ms-user-select: none; /*IE10*/
      -khtml-user-select: none; /*早期浏览器*/
      user-select: none;
    }
    .pangod-classify-content-historyitem {
      display: inline-block;
      width: 80px;
      height: 80px;
      line-height: 80px;
      text-align: center;
      border-radius: 50%;
      background: rgba(150, 150, 150, 0.5);
      color: $white;
      font-weight: bold;
      font-size: 24px;
      cursor: pointer;
      margin: 10px 40px 10px 0;
      position: relative;
      transition: all 0.3s;
      &:last-child {
        margin-right: 0;
        &::after {
          content: "";
        }
      }
      &::after {
        content: "...";
        color: $theme;
        position: absolute;
        left: 110%;
      }
      &:hover {
        transform: scale(1.1);
        background-color: $theme;
      }
    }
    .activecircle {
      transform: scale(1.1);
      background-color: $theme;
    }
    .yearlist {
      overflow-x: scroll;
      white-space: nowrap;
      margin-bottom: 40px;
      width: 916px;
      padding: 0 20px;
      display: inline-block;
      scrollbar-width: none;
      -ms-overflow-style: none; /* IE 10+ */
      -moz-user-select: none; /*火狐*/
      -webkit-user-select: none; /*webkit浏览器*/
      -ms-user-select: none; /*IE10*/
      -khtml-user-select: none; /*早期浏览器*/
      user-select: none;
      &::-webkit-scrollbar {
        display: none; /* Chrome Safari */
      }
    }
  }
}
@media (max-width: 1500px) {
  .pangod-classify-content {
    .yearlist {
      width: 796px;
    }
    .arrow-icon {
      display: none;
    }
  }
}
@media (max-width: 1024px) {
  .pangod-classify-content {
    .timebox {
      width: auto;
      .yearlist {
        width: 60%;
        box-sizing: border-box;
      }
      .el-timeline {
        width: 100%;
        padding: 0 pxToRem(30);
        box-sizing: border-box;
      }
      .el-timeline-item {
        width: 100%;
      }
    }
  }
}
</style>
